/**
 * 内容市场首页
 * @author Kody
 */
import React from 'react';
import { BrowserRouter as PageRouter, Route } from 'react-router-dom';

import { $location } from '@umu/umu-dom';
import { Index as IndexPage } from './routePages/@index';

import { IAppStates } from './context/appContext';

interface IProps {
    initState: IAppStates;
}

export function App(_props: IProps) {
    const baseName = $location.pathname;

    return (
        <PageRouter basename={baseName}>
            <Route exact path="/" component={IndexPage} />
        </PageRouter>
    );
}
